// extracted by mini-css-extract-plugin
export default {"imageContainer":"emptyPages_imageContainer__1VSXy","image":"emptyPages_image__oMJdg","typography":"emptyPages_typography__GIWj8"};